import { Pipe, PipeTransform } from '@vbrick/angular-ts-decorators';
import { escape } from 'underscore';

/**
 * Used to hilight matching sections of content. Works by wrapping matches in a span.ui-match element.
 *
 * Example:  <div> {{text | insightHilight}}</div>
 **/

const rxSpecials = (/[-[\]{}()*+?.,\\^$|#\s]/g);

@Pipe({ name: 'insightHilight' })
export class InsightHilightPipe implements PipeTransform {

	public transform(text: string, search: string, edgeHilight?: boolean): string {
		if(!text){
			return '';
		}
		text = escape(text);
		if(search) {
			search = search.toString().replace(rxSpecials, '\\$&');
			if (edgeHilight) {
				return text.replace(new RegExp('(^|\\s)(' + search + ')', 'gi'), '$1<span class="ui-match">$2</span>');
			}
			else {
				return text.replace(new RegExp(search, 'gi'), '<span class="ui-match">$&</span>');
			}
		}
		return text;
	}
}
